import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { map as _map, uniq as _uniq } from 'lodash';

import IntlDate from 'components/layout/IntlDate';

import RichEditorContent from 'components/RichEditorContent';
import DataId from 'components/DataId';

import FilledQuestionnaireDetails from 'components/modals/FilledQuestionnaireDetails';

import AbstractTimelineEvent from './AbstractTimelineEvent';

class TimelineQuestionnaireFilled extends AbstractTimelineEvent {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
    };
  }

  showDetails = () => {
    this.setState({ showDetails: true });
  };

  closeDetails = () => {
    this.setState({ showDetails: false });
  };

  getQuestionnaireDetails = () => {
    const { filledQuestionnaireDetails } = this.props;
    const filledQuestionnaireId = this.getParam('filledQuestionnaireId') || this.getParam('filledCmsQuestionnaireId');
    return filledQuestionnaireDetails[filledQuestionnaireId]
      ? filledQuestionnaireDetails[filledQuestionnaireId]
      : { pending: true };
  };

  getQuestionsIndex = () => {
    const filledQuestionnaireDetails = this.getQuestionnaireDetails();
    if (!filledQuestionnaireDetails.pending) {
      return _uniq(_map(filledQuestionnaireDetails.data.answers, 'question_index'));
    }

    return null;
  };

  getQuestionsCount = () => {
    const questionsIndex = this.getQuestionsIndex();
    return questionsIndex === null ? null : questionsIndex.length;
  };

  render() {
    const {
      intl: { messages },
      event,
    } = this.props;
    const { showDetails } = this.state;

    const filledQuestionnaireDetails = this.getQuestionnaireDetails();
    let sourceUrl = null;
    const filledQuestionnaireId = this.getParam('filledQuestionnaireId') || this.getParam('filledCmsQuestionnaireId');
    if (this.getParam('filledQuestionnaireId')) {
      sourceUrl = '/api/filledquestionnaires/' + filledQuestionnaireId + '.json';
    } else if (this.getParam('filledCmsQuestionnaireId')) {
      sourceUrl = '/api/cms/leadQuestionnaire/' + filledQuestionnaireId + '.json';
    }

    return (
      <div className="card-block">
        <RichEditorContent content={'<div>' + event.getText() + '</div>'} />

        <div className="p-t-10">
          <DataId dataIdName="filledQuestionnaire" dataIdId={filledQuestionnaireId} url={sourceUrl} />

          {filledQuestionnaireDetails.pending ? (
            <div>
              <i className="fas fa-circle-notch fa-spin" />
            </div>
          ) : (
            <div>
              <p>{messages.infos}</p>
              <dl>
                <dt className="m-t-5">{messages.questionnaire}</dt>
                <dd>{filledQuestionnaireDetails.data.name}</dd>

                <dt className="m-t-5">{messages.filled_out_on}</dt>
                <dd>
                  <IntlDate date={filledQuestionnaireDetails.data.cdate} />
                </dd>

                <dt className="m-t-5">{messages.questions}</dt>
                <dd>{this.getQuestionsCount()}</dd>
              </dl>

              <div className="m-t-10">
                <Button onClick={this.showDetails}>
                  <i className="fa fa-eye" /> {messages.view}
                </Button>
              </div>

              <FilledQuestionnaireDetails
                show={showDetails}
                close={this.closeDetails}
                filledQuestionnaire={filledQuestionnaireDetails}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    filledQuestionnaireDetails: state.dataId.filledQuestionnaire,
  };
};

export default injectIntl(connect(mapStateToProps)(TimelineQuestionnaireFilled));
